import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  prompt: z.string().min(1).max(2000),
  style: z.string().optional(),
  width: z.number().min(256).max(2048).optional().default(1280),
  height: z.number().min(256).max(2048).optional().default(720),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  imageUrl: string;
};

export async function generateSceneImage(input: InputType): Promise<OutputType> {
  const response = await fetch('/_api/music-video/generate-scene-image', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: superjson.stringify(input),
    credentials: 'include',
  });

  if (!response.ok) {
    const err = superjson.parse<{ error: string }>(await response.text());
    throw new Error(err.error || 'Failed to generate scene image');
  }

  return superjson.parse<OutputType>(await response.text());
}
